const SIZE_VALUE_NAMES = ['xxs', 'xs', 'sm', 'base', 'md', 'lg', 'xl'] as const;
const SPACE_VALUE_NAMES = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  ...SIZE_VALUE_NAMES,
] as const;
const WEIGHT_VALUE_NAMES = [
  'thin',
  'extralight',
  'light',
  'normal',
  'medium',
  'semibold',
  'bold',
  'extrabold',
  'black',
] as const;
const SPACE_PROP_NAMES = [
  'marginTop',
  'marginLeft',
  'marginRight',
  'marginBottom',
  'paddingTop',
  'paddingLeft',
  'paddingRight',
  'paddingBottom',
] as const;

export type SizeProp = typeof SIZE_VALUE_NAMES[number];
export type WeightProp = typeof WEIGHT_VALUE_NAMES[number];
export type SpaceProp = typeof SPACE_VALUE_NAMES[number];
export type SpacePropNames = typeof SPACE_PROP_NAMES[number];
export type SpaceProps = Partial<Record<SpacePropNames, SpaceProp>>;

export function getFontSizeCx(size?: SizeProp) {
  if (!size || size === 'base') {
    return null;
  }

  return `text-${size}`;
}

export function getFontWeightCx(weight?: WeightProp) {
  if (!weight) {
    return null;
  }

  return `font-${weight}`;
}

const SPACE_PROP_NAME_TO_CX = {
  marginTop: 'mt',
  marginLeft: 'ml',
  marginRight: 'mr',
  marginBottom: 'mb',
  paddingTop: 'pt',
  paddingLeft: 'pl',
  paddingRight: 'pr',
  paddingBottom: 'pb',
};

type Props = Record<string, any>;
export function getSpaceCx(props: Props) {
  const spacingProps = getSpacingProps(props);

  return (Object.entries(spacingProps) as Array<[SpacePropNames, SpaceProp]>)
    .map(([name, value]) => {
      if (value === 'base') {
        return null;
      }

      return `${SPACE_PROP_NAME_TO_CX[name]}-${value}`;
    })
    .filter(Boolean)
    .join(' ');
}

export function removeSpaceProps(props: Props): Props {
  const newProps: Props = { ...props };
  for (const spacePropIndex in SPACE_PROP_NAMES) {
    const spaceProp = SPACE_PROP_NAMES[spacePropIndex];
    if (newProps[spaceProp]) {
      delete newProps[spaceProp];
    }
  }

  return newProps;
}

function getSpacingProps(props: Props): SpaceProps {
  const spacingProps: SpaceProps = {};
  for (const spacePropIndex in SPACE_PROP_NAMES) {
    const spaceProp = SPACE_PROP_NAMES[spacePropIndex];
    if (props[spaceProp]) {
      spacingProps[spaceProp] = props[spaceProp];
    }
  }

  return spacingProps;
}
